import React, { useEffect, useRef } from 'react';
import Shepherd from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';

// Import Shepherd CSS manually if needed
import './OnboardingTour.css';

const OnboardingTour = ({ isVisible, onComplete }) => {
  const tourRef = useRef(null);

  useEffect(() => {
    console.log('OnboardingTour useEffect - isVisible:', isVisible);
    if (!isVisible) {
      console.log('Tour not visible, returning');
      return;
    }

    console.log('Starting tour...');

    // Initialize Shepherd tour
    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        cancelIcon: {
          enabled: true
        },
        classes: 'shepherd-theme-arrows',
        scrollTo: {
          behavior: 'smooth',
          block: 'center'
        },
        popperOptions: {
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                boundary: 'viewport',
                padding: 10
              }
            },
            {
              name: 'flip',
              options: {
                fallbackPlacements: ['top', 'bottom', 'left', 'right']
              }
            }
          ]
        }
      },
      useModalOverlay: true,
      keyboardNavigation: true
    });

    // Tour steps - آموزش کامل
    tour.addStep({
      id: 'welcome',
      title: 'خوش آمدید به درمووایز! 👋',
      text: 'درمووایز اولین پلتفرم هوشمند آنالیز پوست در ایران است که با استفاده از هوش مصنوعی پیشرفته، راهنمای شخصی شما در مراقبت از پوست خواهد بود. این تور کوتاه به شما کمک می‌کند تا با تمام امکانات آشنا شوید.',
      buttons: [
        {
          text: 'شروع تور',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      id: 'scan-button',
      title: 'اسکن پوست با هوش مصنوعی 🧬',
      text: 'این بخش قلب درمووایز است! با استفاده از دوربین گوشی، پوست شما را با دقت بالا اسکن می‌کنیم و موارد زیر را بررسی می‌کنیم:\n\n• میزان رطوبت و خشکی پوست\n• وضعیت منافذ و جوش‌ها\n• چروک‌ها و خطوط ریز\n• رنگ و یکنواختی پوست\n• حساسیت و التهاب\n\nنتایج آنالیز در کمتر از 30 ثانیه آماده می‌شود!',
      attachTo: {
        element: '[data-tour="scan"]',
        on: 'auto'
      },
      buttons: [
        {
          text: 'قبلی',
          action: tour.back,
          classes: 'shepherd-button-secondary'
        },
        {
          text: 'بعدی',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      id: 'routine-button',
      title: 'روتین مراقبتی شخصی‌سازی شده 📋',
      text: 'بر اساس نتایج آنالیز پوست شما، یک روتین کامل و شخصی‌سازی شده دریافت می‌کنید که شامل:\n\n• مراحل صبحگاهی (پاکسازی، مرطوب‌کننده، ضدآفتاب)\n• مراحل شبانه (پاکسازی عمیق، سرم‌ها، کرم شب)\n• محصولات پیشنهادی مناسب پوست شما\n• زمان‌بندی دقیق استفاده از هر محصول\n• نکات مهم برای بهترین نتیجه\n\nاین روتین به صورت روزانه به شما یادآوری می‌شود!',
      attachTo: {
        element: '[data-tour="routine"]',
        on: 'auto'
      },
      buttons: [
        {
          text: 'قبلی',
          action: tour.back,
          classes: 'shepherd-button-secondary'
        },
        {
          text: 'بعدی',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      id: 'product-analysis',
      title: 'آنالیز هوشمند محصولات پوستی 🧪',
      text: 'قبل از خرید هر محصول پوستی، آن را با درمووایز بررسی کنید! این بخش به شما کمک می‌کند:\n\n• بررسی سازگاری محصول با نوع پوست شما\n• شناسایی مواد تشکیل‌دهنده مفید و مضر\n• هشدار درباره مواد حساسیت‌زا\n• پیشنهاد محصولات مشابه و بهتر\n• امتیازدهی به محصول بر اساس کیفیت\n• نظرات و تجربیات کاربران دیگر\n\nدیگر نگران خرید محصولات نامناسب نباشید!',
      attachTo: {
        element: '[data-tour="product-analysis"]',
        on: 'auto'
      },
      buttons: [
        {
          text: 'قبلی',
          action: tour.back,
          classes: 'shepherd-button-secondary'
        },
        {
          text: 'بعدی',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      id: 'nav-home',
      title: 'خانه - داشبورد اصلی 🏠',
      text: 'صفحه اصلی درمووایز که شامل:\n\n• خلاصه وضعیت فعلی پوست شما\n• آخرین امتیاز آنالیز و روند بهبود\n• تعداد روزهای استفاده پشت سر هم\n• دسترسی سریع به تمام امکانات\n• اعلان‌های مهم و یادآوری‌ها\n• پیشنهادات شخصی‌سازی شده\n\nاین صفحه اولین جایی است که هر روز می‌بینید!',
      attachTo: {
        element: '[data-tour="nav-home"]',
        on: 'auto'
      },
      buttons: [
        {
          text: 'قبلی',
          action: tour.back,
          classes: 'shepherd-button-secondary'
        },
        {
          text: 'بعدی',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      id: 'nav-scanpage',
      title: 'درموآنالیز - اسکن هوشمند 📷',
      text: 'دسترسی مستقیم به بخش اسکن پوست:\n\n• راهنمای کامل نحوه اسکن صحیح\n• تنظیمات دوربین برای بهترین کیفیت\n• آنالیز لحظه‌ای با هوش مصنوعی\n• نمایش نتایج با نمودارهای تعاملی\n• مقایسه با آنالیزهای قبلی\n• پیشنهادات بهبود بر اساس نتایج\n• ذخیره و اشتراک‌گذاری نتایج\n\nهر بار اسکن، اطلاعات جدیدی به پروفایل شما اضافه می‌شود!',
      attachTo: {
        element: '[data-tour="nav-scanpage"]',
        on: 'auto'
      },
      buttons: [
        {
          text: 'قبلی',
          action: tour.back,
          classes: 'shepherd-button-secondary'
        },
        {
          text: 'بعدی',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      id: 'nav-routine',
      title: 'درمو روتین - برنامه مراقبتی 📋',
      text: 'مرکز مدیریت روتین‌های مراقبتی شما:\n\n• مشاهده روتین فعلی صبح و شب\n• ویرایش و شخصی‌سازی مراحل\n• یادآوری‌های هوشمند روزانه\n• پیگیری پیشرفت و نتایج\n• پیشنهاد محصولات جدید\n• مشاوره با متخصصین پوست\n• اشتراک‌گذاری روتین با دوستان\n• تاریخچه تغییرات روتین\n\nروتین شما همیشه به‌روز و متناسب با نیازهای پوستتان است!',
      attachTo: {
        element: '[data-tour="nav-routine"]',
        on: 'auto'
      },
      buttons: [
        {
          text: 'قبلی',
          action: tour.back,
          classes: 'shepherd-button-secondary'
        },
        {
          text: 'بعدی',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      id: 'nav-profitscan',
      title: 'درموفیت - آنالیز محصولات 🧪',
      text: 'کتابخانه هوشمند محصولات پوستی:\n\n• جستجوی محصولات بر اساس نام یا برند\n• اسکن بارکد محصولات برای آنالیز سریع\n• بررسی مواد تشکیل‌دهنده و عوارض جانبی\n• مقایسه محصولات مشابه\n• پیشنهاد محصولات جایگزین بهتر\n• نظرات و امتیازات کاربران\n• قیمت‌گذاری و فروشگاه‌های معتبر\n• هشدارهای امنیتی و تاریخ انقضا\n\nقبل از هر خرید، حتماً درموفیت را چک کنید!',
      attachTo: {
        element: '[data-tour="nav-profitscan"]',
        on: 'auto'
      },
      buttons: [
        {
          text: 'قبلی',
          action: tour.back,
          classes: 'shepherd-button-secondary'
        },
        {
          text: 'پایان تور',
          action: () => {
            tour.complete();
            onComplete && onComplete();
          }
        }
      ]
    });

    // Start the tour
    tour.start();

    // Store tour reference
    tourRef.current = tour;

    // Start the tour
    try {
      tour.start();
      console.log('Tour started successfully');
    } catch (error) {
      console.error('Error starting tour:', error);
    }

    // Cleanup function
    return () => {
      if (tourRef.current) {
        tourRef.current.complete();
      }
    };
  }, [isVisible, onComplete]);

  return null;
};

export default OnboardingTour;
